import { useTranslation } from 'react-i18next';

import styles from './ColorPalettes.module.css';

interface Props {
  colors: readonly string[];
  /** Accessible name of the group. */
  label: string;
  /** Given: every color is a button that chooses it; omitted: a plain preview. */
  onPick?: (color: string) => void;
  disabled?: boolean;
}

/** The ordered colors of a palette, wrapping onto several rows for a long one. */
export function PaletteStrip({ colors, label, onPick, disabled = false }: Props) {
  const { t } = useTranslation();
  if (!onPick) {
    return (
      <span className={styles.strip} role="img" aria-label={`${label}: ${colors.join(', ')}`}>
        {colors.map((color, index) => (
          <span
            key={`${color}-${String(index)}`}
            className={styles.chip}
            style={{ background: color }}
          />
        ))}
      </span>
    );
  }
  return (
    <span className={styles.strip} role="group" aria-label={label}>
      {colors.map((color, index) => (
        <button
          key={`${color}-${String(index)}`}
          type="button"
          className={`${styles.chip} ${styles.chipButton}`}
          style={{ background: color }}
          disabled={disabled}
          aria-label={t('palettes.useColor', { color })}
          title={color}
          onClick={() => {
            onPick(color);
          }}
        />
      ))}
    </span>
  );
}
